import { Component, OnInit } from '@angular/core';
import { SyncService } from '../../services/sync.service';

@Component({
    standalone: false,
    selector: 'app-sync-service-status',
    templateUrl: './sync-service-status.component.html',
    styleUrls: ['./sync-service-status.component.scss']
})
export class SyncServiceStatusComponent implements OnInit {

    constructor(
        private readonly syncService: SyncService
    ) { }

    get isSynchronized(): boolean {
        return this.syncService.isSynchronized;
    }

    ngOnInit(): void {
    }

}
